import { InlineCode } from 'almanac-ui/icons/16'
import { useInlineCodeToggle } from 'common/Prose/Toolbar/hooks/useInlineCodeToggle'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const InlineCodeInlineFormatButton = observer(
  ({ view, callback }: { view: EditorView; callback?: () => void }) => {
    const { active, disabled, handleClick } = useInlineCodeToggle(view)

    return (
      <InlineFormatDropdownMenuItem
        key={'inlineCode'}
        onClick={() => {
          handleClick()
          callback?.()
        }}
        active={active}
        isDisabled={disabled}
        icon={<InlineCode />}
        label="Inline code"
      />
    )
  },
)
